import {SET_FAMILY_FRIENDLY} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_FAMILY_FRIENDLY:
            return {...state, ...action.payload};

        default:
            return state;
    }
};
